import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import pathConfiguration from 'src/configuration/path'
import { FCC } from '~/core/@types/global'
import { Button } from '~/core/ui/Button'
import SectionContainer from './components/section/SectionContainer'

const JourneySection: FCC<{
  className?: string
  hideFeatures?: boolean
  hideTryFreeAction?: boolean
  isGhostBookDemoBtn?: boolean
}> = ({
  className,
  hideFeatures = false,
  hideTryFreeAction = false,
  isGhostBookDemoBtn = true
}) => {
  const { t, i18n } = useTranslation()
  return (
    <SectionContainer
      title="lp:journey_section:title"
      description="lp:journey_section:description"
      tagLabel="lp:journey_section:join_with_us"
      tagColor="bg-purple-100 text-purple-800"
      className={className}>
      <div className="flex align-middle w-full justify-center gap-4 mt-6">
        <Link href={pathConfiguration.contactRequest} locale={i18n?.language}>
          <Button size="xl" label={`${t('lp:request_demo')}`} />
        </Link>
      </div>
    </SectionContainer>
  )
}

export default JourneySection
